import React, { useContext, useState, useEffect } from "react";
import Swal from "sweetalert2";
import {  useNavigate } from 'react-router-dom';
import { resetPasswordSendCode } from "../../api/auth.ts";
import { TranslatorContext } from "../../context/Translator";
import { ButtonComponent, AnchorComponent } from "../../components/elements";
import IconFieldComponent from "../../components/fields/IconFieldComponent";
import LogoComponent from "../../components/LogoComponent";

export default function ForgotPasswordPage() {
  const { t } = useContext(TranslatorContext);
  const navigate = useNavigate();

  
  const [formData, setFormData] = useState({
    email: "",
  });

  
  
  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

 

  const handleSubmit = (e) => {
    
    e.preventDefault();

    console.log(formData);

    resetPasswordSendCode(formData.email).then((res) => {
      if (res.error === true) {
        Swal.fire({
          text: res.msg,
          icon: "warning",
          confirmButtonText: "Ok",
        });
        return;
      } else {
        
        Swal.fire({
          text: "Se ha enviado un email con el código de recuperación.",
          icon: "success",
          confirmButtonText: "Ok",
        });
        navigate('/recuperar-password/verificar-codigo/' + res.uuid);
       
      }
    });
  };

  

  return (
    <div>
      
        <div className="mc-auth">
          <img src="images/Login.png" alt="pattern" className="mc-auth-pattern mc-auth-pattern-desktop" />
      <img 
        src="images/Loginphone.png" 
        alt="pattern" 
        className="mc-auth-pattern mc-auth-pattern-mobile"
        onError={(e) => {
          // Fallback a la imagen desktop si la móvil no existe
          e.target.src = "images/Login.png";
        }}
      />
          <div className="mc-auth-group">
            <br></br>
         <br></br>
          <br></br>
           <br></br>
            <br></br>
             <br></br>
              <br></br>
               <br></br>
           
            <h4 className="mc-auth-title">Ingrese su email</h4>
            <form className="mc-auth-form" onSubmit={handleSubmit}>
              <IconFieldComponent
                icon="email"
                type="email"
                name="email"
                classes="h-sm"
                placeholder="Ingrese su email"
                onChange={handleInputChange}
              />
              <ButtonComponent className="mc-auth-btn h-sm" type="submit">
                Enviar link de recuperación
              </ButtonComponent>
            </form>
            <div className="mc-auth-navigate">
              <span>¿Recuerdas la contraseña?</span>
              <AnchorComponent to="/login">{t("login")}</AnchorComponent>
            </div>
          </div>
        </div>
      
    </div>
  );
}